import { render, staticRenderFns } from "./query_automatic.vue?vue&type=template&id=c0418434&scoped=true&"
import script from "./query_automatic.vue?vue&type=script&lang=js&"
export * from "./query_automatic.vue?vue&type=script&lang=js&"
import style0 from "./query_automatic.vue?vue&type=style&index=0&id=c0418434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0418434",
  null
  
)

export default component.exports